// Slides a highlight under the active item of a segmented control or the bottom nav.
// The element gets --ind-x / --ind-w / --ind-o (opacity) and, after the first placement, the class
// "slide-ready". CSS draws the pill with ::before and animates it; before "slide-ready" the active item
// paints its own background, so nothing flashes and no-JS still shows the selection.
export function placeIndicator(container, activeSelector) {
  if (!container) return;
  const active = container.querySelector(activeSelector);
  if (!active) {
    container.style.setProperty('--ind-o', '0');
    return;
  }
  container.style.setProperty('--ind-x', active.offsetLeft + 'px');
  container.style.setProperty('--ind-w', active.offsetWidth + 'px');
  container.style.setProperty('--ind-o', '1');
  if (!container.classList.contains('slide-ready')) {
    // enable the transition only after the first position is painted, so it does not slide in from 0
    requestAnimationFrame(() => requestAnimationFrame(() => container.classList.add('slide-ready')));
  }
}

// Keeps the indicator right when the container resizes (rotation, zoom, font load).
export function observeIndicator(container, activeSelector) {
  if (!container || typeof ResizeObserver === 'undefined') return null;
  const ro = new ResizeObserver(() => placeIndicator(container, activeSelector));
  ro.observe(container);
  return ro;
}
